import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button, Col, FormGroup, Label, Row, Collapse } from "reactstrap";
import CustomSelect from "../../../Common/CustomSelect";
import { getDefaultValueForSelect } from "../../../../helpers/utils";
import classnames from "classnames";
import FormByCostCPI from "./FormByCostCPI";
import FormByCostCPA from "./FormByCostCPA";
import AgencyCommissionForm from "./AgencyCommissionForm";
import FormByCostTypeRM from "./FormByCostTypeRM";

const FormByCostType = ({
  cost,
  type,
  setGroups,
  events,
  offer_data,
  isFormSubmit = false,
  isLoading = false,
  accordion_status = false,
  suffix = "",
  onDelete,
  countries,
  offer,
  onChangeCountries,
}) => {
  const [collapsed, setCollapsed] = React.useState(accordion_status);

  const kpi_indicator_options = [
    { label: "Revenue", value: "revenue" },
    { label: "Event %", value: "a_c_event_percent" },
    { label: "Retention", value: "retention" },
    { label: "CPI", value: "cpi" },
    { label: "Cost per event", value: "cost_per_event" },
    { label: "Average order value", value: "AOV" },
  ];

  const trackers = [
    { label: "Adjust", value: "Adjust" },
    { label: "AppsFlyer", value: "AppsFlyer" },
  ];

  const getForm = () => {
    switch (type) {
      case "cpi":
        return (
          <FormByCostTypeStyled key={cost.key + "_1"}>
            <FormByCostCPI
              isLoading={isLoading}
              offer_data={offer_data}
              isFormSubmit={isFormSubmit}
              cost={cost}
              suffix={suffix}
              setGroups={setGroups}
              trackers={trackers}
              events={events}
              offer={offer}
            />
          </FormByCostTypeStyled>
        );
      case "a_c":
        return (
          <FormByCostTypeStyled key={cost.key + "_2"}>
            <AgencyCommissionForm
              cost={cost}
              kpi_indicator_options={kpi_indicator_options}
              isFormSubmit={isFormSubmit}
              isLoading={isLoading}
              suffix={suffix}
              setGroups={setGroups}
              offer_data={offer_data}
              offer={offer}
            />
          </FormByCostTypeStyled>
        );
      case "cpa":
        return (
          <FormByCostTypeStyled key={cost.key + "_3"}>
            <FormByCostCPA
              isLoading={isLoading}
              offer_data={offer_data}
              isFormSubmit={isFormSubmit}
              cost={cost}
              trackers={trackers}
              events={events}
              suffix={suffix}
              setGroups={setGroups}
              offer={offer}
            />
          </FormByCostTypeStyled>
        );
      case "r_m":
        return (
          <FormByCostTypeStyled key={cost.key + "_4"}>
            <FormByCostTypeRM
              isLoading={isLoading}
              offer_data={offer_data}
              isFormSubmit={isFormSubmit}
              cost={cost}
              setGroups={setGroups}
              trackers={trackers}
              events={events}
              suffix={suffix}
              offer={offer}
            />
          </FormByCostTypeStyled>
        );
      default:
        return <></>;
    }
  };

  const getLabelCountries = (data = []) => {
    if (data.length === 0) return "All countries";
    if (!countries || countries?.length === 0) return "Waiting...";

    const rez = data.map(val => {
      if (typeof val === "object") {
        return countries.find(i => i.value === val.value)?.label || "";
      } else {
        return countries.find(i => i.value === val)?.label || "";
      }
    });

    return rez.join(", ");
  };

  return (
    <Row className="justify-content-md-center">
      <Col xl={12}>
        <div
          className=""
          style={{ borderLeft: "5px solid #556EE6", margin: "10px 0" }}
        >
          <div className="accordion" id="accordion">
            <AccordionItem className={classnames("accordion-item")}>
              <h2 className="accordion-header" id="headingOne">
                <span
                  className={classnames(
                    "accordion-button fw-medium d-flex justify-content-between",
                    {
                      collapsed: !collapsed,
                    }
                  )}
                  // type="button"
                  onClick={() => setCollapsed(!collapsed)}
                  style={{ cursor: "pointer", borderTopLeftRadius: 0 }}
                >
                  <div className="w-100 m-0 m-auto d-flex justify-content-between align-items-center pe-3">
                    <span>{getLabelCountries(cost?.countries)}</span>
                    <Button
                      onClick={onDelete || function () {}}
                      color="danger"
                      className="btn-block inner me-3 btn-sm"
                      style={{ visibility: !onDelete ? "hidden" : "visible" }}
                    >
                      <i className="mdi mdi-trash-can font-size-16" />
                    </Button>
                  </div>
                </span>
              </h2>

              <Collapse isOpen={collapsed} className="accordion-collapse">
                <AccordionBody className="accordion-body">
                  <div className="w-50 m-auto mt-3 mb-3">
                    <Row>
                      <Col md={12}>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="">Countries:</Label>
                              <CustomSelect
                                name={"countries" + suffix}
                                options={countries}
                                defaultValue={getDefaultValueForSelect(
                                  cost?.countries
                                )}
                                placeholder="Select countries..."
                                classNamePrefix="select2-selection"
                                errorMessage="Countries field is required"
                                onChange={onChangeCountries}
                                changeOptionsRender
                                isMulti
                                // required
                                isLoading={isLoading}
                                isFormSubmit={isFormSubmit}
                              />
                              {/*<Select*/}
                              {/*  options={countries}*/}
                              {/*  onChange={onChangeCountries}*/}
                              {/*  multiple*/}
                              {/*  isMulti*/}
                              {/*/>*/}
                            </FormGroup>
                          </Col>
                          {getForm()}
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </AccordionBody>
              </Collapse>
            </AccordionItem>
          </div>
        </div>
      </Col>
    </Row>
  );
};

const AccordionItem = styled.div`
  background-color: transparent;
  border: 0px solid rgba(0, 0, 0, 0) !important;
  margin: 0;
  cursor: initial;

  /* .accordion-button::after {
    background: none !important;
    display: none !important;
  } */

  &:first-child {
    margin-top: 0;
  }

  .accordion-button {
    padding-top: 8px;
    padding-bottom: 8px;

    &.collapsed {
      color: #4d63cf;
      background-color: #eef1fd !important;
      /* box-shadow: inset 0 calc(var(--bs-accordion-border-width) * -1) 0 var(--bs-accordion-border-color); */
    }
  }

  .btn-danger {
    margin: 0 !important;
  }

  &.accordion-item__is-close {
    background-color: red !important;
  }
`;

const AccordionBody = styled.div`
  padding: 0 !important;
  color: #74788d !important;
`;

FormByCostType.propTypes = {
  type: PropTypes.string,
  events: PropTypes.any,
  isFormSubmit: PropTypes.bool,
  isLoading: PropTypes.bool,
  offer_data: PropTypes.any,
  offer: PropTypes.any,
  cost: PropTypes.any,
  suffix: PropTypes.string,
  onDelete: PropTypes.func,
  countries: PropTypes.array,
  onChangeCountries: PropTypes.func,
  setGroups: PropTypes.func,
  accordion_status: PropTypes.bool,
};

const FormByCostTypeStyled = styled.div`
  .btn__add-custom-event {
    color: #556ee6ff;
    cursor: pointer;
    font-size: 11px;
  }
`;

export default FormByCostType;
